import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Footer from './components/Footer';
import ServicesSection from './components/ServicesSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import TestimonialsSection from './components/TestimonialsSection';
import ITProfilesSection from './components/ITProfilesSection';
import ContactSection from './components/ContactSection';
import AnimatedSection from './components/AnimatedSection';
import WhatsAppWidget from './components/WhatsAppWidget';

const App: React.FC = () => {
  return (
    <div className="App min-h-screen bg-gray-50">
      <Header />
      <main>
        <AnimatedSection animation="fade-up" duration={0.8}>
          <Hero />
        </AnimatedSection>
        
        <AnimatedSection animation="fade-up" delay={0.1}>
          <ServicesSection />
        </AnimatedSection>
        
        <AnimatedSection animation="fade-up" delay={0.1}>
          <WhyChooseUsSection />
        </AnimatedSection>
        
        <AnimatedSection animation="fade-up" delay={0.1}>
          <TestimonialsSection />
        </AnimatedSection>
        
        <AnimatedSection animation="fade-up" delay={0.1}>
          <ITProfilesSection />
        </AnimatedSection>
        
        <AnimatedSection animation="zoom-in" delay={0.1}>
          <ContactSection />
        </AnimatedSection>
      </main>
      <Footer />
      
      {/* WhatsApp Widget flotante */}
      <WhatsAppWidget />
    </div>
  );
};

export default App;
